import "./PayoffDiagramControlsComponent.scss";
import {IComponentOptions, IOnDestroy, IPostLink, IScope, ITimeoutService} from "angular";
import {PayoffDiagramComponentController} from "../../PayoffDiagramComponent";
import {SystemEventService} from "../../../../../../services/system-state/SystemEventService";
import {ReplaySubject, Subject} from "rxjs";
import {SystemEvent} from "../../../../../../services/system-state/SystemEvent";

export const PayoffDiagramTopControls = "tfPayoffDiagramTopControls";

export function payoffDiagramTopControls(): IComponentOptions {
    return {
        templateUrl: "app/components/charts/payoff/payoff-diagram/components/top-controls/PayoffDiagramControlsComponent.html",
        require: {
            diagram: "^^tfPayoffDiagram"
        },
        controllerAs: "ctrl",
        controller: PayoffDiagramControlsComponentController
    };
}

export class PayoffDiagramControlsComponentController implements IPostLink, IOnDestroy {

    public diagram: PayoffDiagramComponentController;

    public timeSeriesModel = {
        value: 3,
        options: {
            floor: 2,
            ceil: 8,
            onEnd: () => this.inputsChanged()
        }
    };

    public pricePointsModel = {
        value: 5,
        options: {
            floor: 5,
            ceil: 35,
            onEnd: () => this.inputsChanged()
        }
    };

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope,
                       private $timeout: ITimeoutService,
                       private systemEventService: SystemEventService) {
        this.systemEventService
            .eventsOfType(SystemEvent.VIEW_RESIZE)
            .takeUntil(this.destroyed$)
            .subscribe(this.resizeSliders.bind(this));
    }

    public $postLink(): void {
        this.inputsChanged();
    }

    private resizeSliders() {
        this.$timeout(() => {
            this.$scope.$broadcast("rzSliderForceRender");
        }, 500); // Delay is to wait for animations to happen
    }

    private inputsChanged() {
        const inputs = {
            timeSeries: this.timeSeriesModel.value,
            pricePoints: this.pricePointsModel.value
        };
        this.diagram.updateTimeInputs(inputs);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
